import { Collection } from '@msw/data'
import { userInfoSchema } from 'app/src/msw/membership/schemas/userInfoSchema'
import type { UserInfo } from 'app/src/services/welfareportal/membership-api'

// USER INFO COLLECTION
const userInfoCollection = new Collection({
  schema: userInfoSchema,
})

export { userInfoCollection }
export const createUserInfoSeed = async (overrides?: {
  firstName?: string
  lastName?: string
  email?: string
  onlyDiscount?: boolean
  onlyCatalog?: boolean
  onlyPlus?: boolean
}) => {
  const existingData = await userInfoCollection.findMany()

  if (existingData.length > 0) {
    return
  }

  const jsonData = await (await fetch('./data/membership/userInfo.json')).json()
  jsonData.items.forEach(async (item: UserInfo) => {
    if (overrides?.firstName && overrides?.lastName) {
      item.firstName = overrides.firstName
      item.lastName = overrides.lastName
    }

    if (overrides?.email) {
      item.email = overrides.email
      item.userId = overrides.email
    }

    // Filtra le userMemberships in base ai parametri
    if (overrides?.onlyDiscount || overrides?.onlyCatalog || overrides?.onlyPlus) {
      item.userMemberships = item.userMemberships?.filter((membership) => {
        const name = membership.campaignName?.toLowerCase() || ''
        if (overrides.onlyPlus && name.includes('plus')) {
          return true
        }
        if (overrides.onlyCatalog && name.includes('catalogo') && !name.includes('plus')) {
          return true
        }
        if (overrides.onlyDiscount && name.includes('sconti') && !name.includes('plus')) {
          return true
        }

        return false
      })
    }

    const createdUserInfo = await userInfoCollection.create(item)
    console.log('createUserInfoSeed', createdUserInfo, overrides)
  })
  console.log('MSW: Seeding UserInfo data')
}

export const clearUserInfoSeed = async () => {
  const existingData = await userInfoCollection.findMany()
  existingData.forEach(async (item) => {
    await userInfoCollection.delete(item)
  })
  console.log('MSW: Clearing UserInfo data')
}
